import {
  CheckboxType,
  GoogleSitesType,
  ImageType,
  InputType,
  LinkType,
  RecaptchaType,
  SelectType,
  TextType,
  TitleType,
} from "../types"

export const DEFAULT_SELECT_STYLES = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    backgroundColor: "#f8ebe3",
    borderColor: "#636466",
    borderRadius: 0,
    boxShadow: "unset",
    fontWeight: 600,
    fontSize: "14px",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingLeft: "10px",
    ":hover": {
      ...baseStyles[":hover"],
      borderColor: "inherit",
    },
  }),
  singleValue: (baseStyles: any, _state: any) => ({
    ...baseStyles,
    color: "#636466",
  }),
  menu: (baseStyles: any, _state: any) => ({
    ...baseStyles,
    color: "#636466",
    backgroundColor: "#f8ebe3",
    padding: "20px 0 20px 20px",
  }),
  menuList: (baseStyles: any, _state: any) => ({
    ...baseStyles,
    color: "#636466",
    borderLeft: "1px solid rgba(99,100,102,.5)",
    paddingLeft: "15px",
  }),
  indicatorSeparator: (baseStyles: any, _state: any) => ({
    ...baseStyles,
    width: 0,
  }),
  dropdownIndicator: (baseStyles: any, state: any) => ({
    ...baseStyles,
    transition: "transform 0.5s",
    transform: `rotate(${state.isFocused ? "0deg" : "-90deg"})`,
    ":active": {
      transform: "rotate(0deg)",
    },
  }),
  option: (baseStyles: any, state: any) => {
    return {
      ...baseStyles,
      color: state.isSelected ? "636466" : "#636466",
      backgroundColor: "#f8ebe3",
      ":hover": {
        ...baseStyles[":hover"],
        backgroundColor: state.isFocused ? "#d8bbaa" : "#d8bbaa",
        color: "white",
      },
      ":active": {
        ...baseStyles[":active"],
        backgroundColor: state.isSelected ? "#d8bbaa" : "#d8bbaa",
        color: "white",
      },
    }
  },
}

export interface RequestParamsType {
  [param: string]: string | number | null
}
export interface HeadersType {
  [param: string]: string
}

export interface APIResponseType {
  success?: boolean
  errors?: { [input: string]: string[] }
  error?: string
  msg?: string
  status: number
  [k: string]: any
}
export const json_request = async (
  url: string,
  params: RequestParamsType,
  method: "get" | "post" = "post",
  headers: HeadersType = {}
): Promise<APIResponseType> => {
  if (url.includes(process.env.API_HOST as string)) {
    headers["project-id"] = process.env.PROJECT as string
  }
  let config: any = {
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    method: method.toUpperCase(),
  }
  if (method === "post") {
    config.body = JSON.stringify(params)
  } else {
    url = `${url}?${new URLSearchParams(
      Object.entries(params).map(([k, v]) => [k, v === null ? "" : `${v}`])
    )}`
  }
  try {
    let response = await fetch(url, config)
    return { ...(await response.json()), status: response.status }
  } catch (error) {
    console.error(error)
    return { success: false, error: "Request failed", status: 400 }
  }
}

export interface FormFieldsType {
  [field: string]:
    | InputType
    | TitleType
    | TextType
    | LinkType
    | ImageType
    | SelectType
    | RecaptchaType
    | CheckboxType
    | GoogleSitesType
}

export interface FormSettingsType {
  pk: number
  name: string
  form_method: "get" | "post"
  form_recipient?: number
  form_submit: string
  form_redirection?: string | null
  form_success_msg?: string | null
  form_ajax_request?: boolean | null
  recaptcha_v3: boolean
  recaptcha_action: string
}

export type FormItemType = string | FormSectionFieldType

export interface FormSectionFieldType {
  name: string
  children: FormItemType[]
}

export interface FormType {
  settings: FormSettingsType
  fields: FormFieldsType
  items: FormItemType[]
}

const INPUT_EVENT_VALUES: any = {
  select: (e: any) => e.value,
  input: (e: any) => e.target.value,
  textarea: (e: any) => e.target.value,
  "google-places": (e: any) => e.target.value,
}

export const getInputEventValue = (inputType: string, event: any) =>
  INPUT_EVENT_VALUES.hasOwnProperty(inputType)
    ? INPUT_EVENT_VALUES[inputType](event)
    : event

const INPUT_HUMAN_VALUES: any = {}

export const getInputHumanValue = (inputType: string, value: any) =>
  INPUT_HUMAN_VALUES.hasOwnProperty(inputType)
    ? INPUT_HUMAN_VALUES[inputType](value)
    : value
